// @flow
import * as React from 'react';

import { Field } from 'redux-form';
import { FormSelect, FormRadio } from '../../../../components';
import { SQUAD_SIZE, league_tooltips } from '../../../../helpers';

export const GameplaySettings = () => (
	<div>

		<Field
			label='Squad Size & Layout'
			name='squad_size'
			options={SQUAD_SIZE}
			component={FormSelect}
			tooltip={league_tooltips.squad_size}
		/>

		<FormRadio
			label='Captains'
			name='captains'
			elements={[
				{
					value: 1,
					text: 'On',
				},
				{
					value: 0,
					text: 'Off',
				}
			]}
			tooltip={league_tooltips.captains}
			is_disabled={false}
		/>

		<FormRadio
			label='Emergencies'
			name='emergency'
			elements={[
				{
					value: 1,
					text: 'On',
				},
				{
					value: 0,
					text: 'Off',
				}
			]}
			tooltip={league_tooltips.emergency}
			is_disabled={false}
		/>

		<FormRadio
			label='Rolling Lockout'
			name='lockout'
			elements={[
				{
					value: 1,
					text: 'On',
				},
				{
					value: 0,
					text: 'Off',
				}
			]}
			tooltip={league_tooltips.lockout}
			is_disabled={false}
		/>
	</div>
);

export default GameplaySettings;


// WEBPACK FOOTER //
// ./src/pages/leagues/leaguesCreate/forms/GameplaySettings.js